///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-category.ts"/>

module Meevo.Components.Controls.SmartMover {


    import IReportEmployee = Meevo.Plugins.Reports.IReportEmployee;
    import IReportEmployeeCategory = Meevo.Plugins.Reports.IReportEmployeeCategory;
    import EmployeeCategory = Model.EmployeeCategoryListItem;
    import Employee = Model.EmployeeListItem;

    export class EmployeeToCategoriesStrategy implements ICollectionPopulate {
        constructor(private employeeCat: ICollectionBase<IReportEmployeeCategory>, private employees: ICollectionBase<IReportEmployee>) {
        }

        populate(): void {
            this.employeeCat.models.forEach((category: ISmartMoverCategoryModel<IReportEmployeeCategory>) => {
                category.resetModels([]);
            });

            for (const category of this.employeeCat.models) {
                (<ISmartMoverCategoryModel<IReportEmployeeCategory>>category).resetModels(
                    this.employees.models.filter(model => {
                        const categoriesIds: string[] = model.get('employeeCategories').map(row => row.id);

                        return categoriesIds.indexOf(category.id as string) !== -1;
                    })
                );
            }
        }
    }

    export class CoreEmployeeToCategoryStrategy implements ICollectionPopulate {
        constructor(public parent: ICollectionBase<EmployeeCategory>, public child: ICollectionBase<Employee>) {
        }

        populate(): void {
            for (const category of this.parent.models) {
                (<ISmartMoverCategoryModel<EmployeeCategory>>category).resetModels(
                    this.child.models.filter((employee) => {
                        const categoriesIds: string[] = employee.get('employeeCategories').map(row => row.id);

                        return categoriesIds.indexOf(category.id as string) !== -1;
                    })
                );
            }
        }
    }
}